export const VISIT_EXPIRATION_WARNING_THRESHOLD_SECONDS = 180;
export const SET_VISIT_EXPIRES_AT = 'SET_VISIT_EXPIRES_AT';
export const VISIT_EXPIRATION_WARNING = 'VISIT_EXPIRATION_WARNING';
export const VISIT_EXPIRATION_TICK = 'VISIT_EXPIRATION_TICK';
export const VISIT_EXPIRED = 'VISIT_EXPIRED';
export const CLEAR_VISIT_EXPIRATION = 'CLEAR_VISIT_EXPIRATION';
export const DISMISS_VISIT_EXPIRATION_WARNING =
  'DISMISS_VISIT_EXPIRATION_WARNING';

export const setVisitExpiresAt = (expiresAt) => ({
  type: SET_VISIT_EXPIRES_AT,
  payload: expiresAt,
});

export const visitExpirationWarning = (secondsRemaining) => ({
  type: VISIT_EXPIRATION_WARNING,
  payload: secondsRemaining,
});

export const visitExpirationTick = (secondsRemaining) => ({
  type: VISIT_EXPIRATION_TICK,
  payload: secondsRemaining,
});

export const visitExpired = () => ({
  type: VISIT_EXPIRED,
});

export const clearVisitExpiration = () => ({
  type: CLEAR_VISIT_EXPIRATION,
});

export const dismissVisitExpirationWarning = () => ({
  type: DISMISS_VISIT_EXPIRATION_WARNING,
});

const initialState = {
  visitExpiresAt: null,
  isWarningVisible: false,
  secondsRemaining: 0,
};

export const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case SET_VISIT_EXPIRES_AT:
      return {
        ...state,
        visitExpiresAt: payload,
        isWarningVisible: false,
        secondsRemaining: 0,
      };
    case VISIT_EXPIRATION_WARNING:
      return {
        ...state,
        isWarningVisible: true,
        secondsRemaining: payload,
      };
    case VISIT_EXPIRATION_TICK:
      return {
        ...state,
        secondsRemaining: payload,
      };
    case VISIT_EXPIRED:
      return {
        ...state,
        visitExpiresAt: null,
        isWarningVisible: false,
        secondsRemaining: 0,
      };
    // Intentionally only hides the modal without stopping the countdown.
    // The countdown continues in the background so that when it reaches zero,
    // visitExpiredActionEpic fires and shows an alert requiring manual intervention
    // (void payments and cancel). This only applies to the split-tender case.
    case DISMISS_VISIT_EXPIRATION_WARNING:
      return {
        ...state,
        isWarningVisible: false,
      };
    case CLEAR_VISIT_EXPIRATION:
      return initialState;
    default:
      return state;
  }
};
